<template>
  <section class="menu-trigger">
    <button class="home-button" @click="toggleMenu" aria-label="Open main menu">
      <span :style="{ backgroundColor: color }"></span>
      <span :style="{ backgroundColor: color }"></span>
      <span :style="{ backgroundColor: color }"></span>
    </button>
    <button
      :style="{ color: color }"
      class="text-button login-btn"
      v-if="!loggedIn"
      @click="$modal.show('login')"
    >
      Inloggen
    </button>
    <button
      :style="{ color: color }"
      class="text-button btn-name"
      v-else
      @click="toggleMenu"
    >
      <span class="" v-if="user.name">
        {{ user.name }}
      </span>
    </button>
  </section>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.rootStore.loggedIn
    },
    user() {
      return this.rootStore.user
    },
    theme() {
      return this.rootStore.theme
    },
    color() {
      return this.theme.header.color
        ? this.theme.header.color
        : this.theme.mainColor
    }
  },
  methods: {
    toggleMenu() {
      this.rootStore.toggleSideBar(true)
    }
  }
}
</script>

<style lang="scss" scoped>
#menu-trigger {
  position: fixed;
  margin: 15px;
  z-index: 20;

  @media only screen and (min-width: 940px) {
    margin: 32px;
  }
}

.login-btn {
  padding-right: 18px;
}

.home-button {
  width: 46px;
  height: 46px;
  border-radius: 23px;
  padding: 17px 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: white;
  box-shadow: rgba($color: #000000, $alpha: 0.33) 0 0px 32px -4px;

  span {
    background-color: #000;
    display: block;
    border-radius: 4px;
    height: 2px;
    &:first-child {
      width: 16px;
    }
    &:nth-child(2) {
      width: 10px;
    }
    &:nth-child(3) {
      width: 13px;
    }
  }
}

.text-button {
  display: none;
  font-weight: 400;
  max-width: 118px;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}

button {
  //(--main-color);
  font-size: 0.82rem;
  background: transparent;
  line-height: normal;
}

@media only screen and (min-width: 768px) {
  .menu-trigger {
    background: white;
    display: inline-flex;
    height: 46px;
    border-radius: 23px;
    box-shadow: rgba($color: #000000, $alpha: 0.33) 0 0 32px -4px;
    align-items: center;
    // padding-right: 18px;
  }
  .btn-name {
    padding-right: 18px;
  }
  .home-button {
    box-shadow: none;
  }

  .text-button {
    display: inline-block;
  }
}
</style>
